import React, { Component } from 'react';
import { MuiColorInput } from 'mui-color-input';

// intended to encapsulate 3rd party library, for when we ever have to switch/upgrade
export default class ColorInput extends Component {
    render() {
        return <MuiColorInput format="hex" isAlphaHidden={true} value={this.props.value} onChange={this.props.onChange} />;
    }
}